export enum NewsBoxType {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
